import React from 'react'
import { useQuery } from 'react-query'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { getGiftTemplates } from '../api'
import { ERROR_GETTING_GIFT_TEMPLATE_CATEGORIES } from '../errorConstants'

const useFetchGiftTemplates = (page, limit, isSmb, isEnabled = false) => {
    const { data, error, isLoading, isSuccess, isError } = useQuery(
        [
            'getGiftTemplates',
            {
                page: page,
                limit: limit,
                smb: isSmb,
            },
        ],
        getGiftTemplates,
        {
            enabled: isEnabled,
            onError: (error) => {
                error.name = ERROR_GETTING_GIFT_TEMPLATE_CATEGORIES
                Sentry.captureException(error, {
                    contexts: {
                        data: {
                            errorMessage:
                                ERROR_GETTING_GIFT_TEMPLATE_CATEGORIES,
                        },
                    },
                    user: {
                        id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                    },
                })
            },
            refetchOnWindowFocus: false,
        }
    )

    return { data, error, isLoading, isSuccess, isError }
}

export default useFetchGiftTemplates
